<div class="login-top-bar">
  <div class="login-logo">
    <img src="../../assets/img/Logo_bianco.png" alt="Logo" />
  </div>
  <div class="background-logo">
    <img src="../../assets/img/sfondo_frecce.png" alt="Background-logo" class="mt-4 side-logo" />
  </div>
</div>
<div class="login-container">
  <div class="row w-100 h-100 text-center">
    <div class="col-12 d-flex flex-column mt-4">
      <div class="d-flex flex-column justify-content-between w-100 h-100 align-items-center">
        <div class="text-center sent-password">
          <h1 class="login-title mt-4">{{ 'PASSWORD_RESET_CONFIRMATION.TITLE' | translate }}</h1>
          <p class="confirmation-message mt-4 sent-password-subtitle">
            {{ 'PASSWORD_RESET_CONFIRMATION.MESSAGE' | translate }}
          </p>
          <div class="w-100 d-flex justify-content-center mt-5">
            <app-back-button
              [linkText]="'PASSWORD_RESET_CONFIRMATION.BACK_TO_LOGIN'"
              [routerLink]="['/login']"
              [direction]="'back'"
            />
          </div>
        </div>
        <div class="d-flex w-100 justify-content-center">
          <div class="mt-5">
            <div class="login-footer justify-content-center">
              <div class="pb-3" id="icamRights">
                <span> &copy; {{ getYear() }} ICAM S.P.A - All rights reserved </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
